<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="card border-0">
          <div class="card-body">
            <p class="card-text font-weight-lighter">{{ text }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "FooterComponent",
  props: {
    text: String,
  },
}
</script>

<style scoped>

</style>
